import React from 'react';
import { cn } from '@/lib/utils';
import './primitives.css';

/**
 * Titled panel (a tone step, no outline). `icon` is accepted for older callers and not drawn:
 * a heading names the panel on its own. The heading level defaults to h2 (pages have one h1 from
 * PageHeader); pass `as="h3"` when nesting.
 *
 *   <SectionCard title="Monitored domains" subtitle="Verified domains only" icon={Globe}
 *                actions={<Button size="sm">Add</Button>} footer={...}>
 *     ...
 *   </SectionCard>
 */
export default function SectionCard({
  title,
  subtitle,
  // eslint-disable-next-line no-unused-vars
  icon,
  actions,
  footer,
  as: Heading = 'h2',
  className = '',
  contentClassName = '',
  children,
  ...rest
}) {
  return (
    <section className={cn('is-card flex flex-col', className)} {...rest}>
      {(title || actions) && (
        <div className="is-card-head">
          <div className="flex items-center gap-2 min-w-0">
            <div className="min-w-0">
              {title && <Heading className="t-heading truncate">{title}</Heading>}
              {subtitle && <p className="t-small" style={{ marginTop: 2 }}>{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
        </div>
      )}
      <div className={cn('is-card-body flex-1', contentClassName)}>{children}</div>
      {footer && <div className="is-card-foot">{footer}</div>}
    </section>
  );
}
